export interface EsgSubmissionState {
  templateUploadId: string | null
  submissions: EsgSubmission[]
}

export const useEsgSubmissionStore = defineStore('esgSubmission', {
  state: (): EsgSubmissionState => ({
    templateUploadId: null,
    submissions: [],
  }),

  actions: {
    setSubmissionData(templateUploadId: string, submissions: EsgSubmission[]) {
      this.templateUploadId = templateUploadId
      this.submissions = submissions
    },

    clearSubmissionData() {
      this.templateUploadId = null
      this.submissions = []
    },
  },
})
